import { NewExportConfiguration } from "@/models/api/administration/servicesAndAttributes/NewExportConfiguration";
import { Expose, Type } from "class-transformer";
import { IsArray, IsNumber, IsString, ValidateNested } from "class-validator";

export class ExportConfiguration extends NewExportConfiguration {
  @Expose()
  @IsNumber()
  id!: number;
}

export class OfficeProfileResult {
  @Expose()
  @IsNumber()
  id!: number;
  @Expose()
  @IsString()
  name!: string;
}

export class ExportConfigurationSetting {
  @Expose()
  @IsNumber()
  id!: number;
  @Expose()
  @IsString()
  name!: string;
  @Expose()
  @IsString()
  comment!: string;
}

export class ServiceTypeExportConfiguration {
  @Expose()
  @Type(() => ExportConfiguration)
  @IsArray()
  @ValidateNested()
  exportConfigurations!: Array<ExportConfiguration>;
  @Expose()
  @Type(() => OfficeProfileResult)
  @IsArray()
  @ValidateNested()
  officeProfiles!: Array<OfficeProfileResult>;
  @Expose()
  @Type(() => ExportConfigurationSetting)
  @IsArray()
  @ValidateNested()
  exportConfigurationSettings!: Array<ExportConfigurationSetting>;
}
